import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home-zong",
  "use": "icon-home-zong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home-zong\"><path fill=\"currentColor\" d=\"M851.2 128C761.6 51.2 640 0 512 0 403.2 0 307.2 32 224 89.6L512 460.8 851.2 128 851.2 128zM499.2 544 172.8 128C70.4 224 0 358.4 0 512c0 281.6 230.4 512 512 512s512-230.4 512-512c0-6.4 0-19.2 0-25.6L499.2 544 499.2 544zM1017.6 422.4C998.4 326.4 960 243.2 896 172.8L601.6 467.2 1017.6 422.4 1017.6 422.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol